const document = '["###.###.###-##", "##.###.###/####-##"]';
const cnpj = '##.###.###/####-##';
const cpf = '###.###.###-##';
const cep = "#####-###";
const date = '##/##/####';
const numeric = '#*';
const hour = '##:##';
const money = "#*.##";
const degrees = "#*.##";
const phone = '["(##) ####-####", "(##) #####-####"]';
const size = '["#", "#.#", "#.##"]';

export default {
    size,
    document,
    cnpj,
    cpf,
    cep,
    hour,
    date,
    numeric,
    phone,
    money,
    degrees
}
